/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type DeleteServiceAccountAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err: DeleteServiceAccountAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type DeleteServiceAccountAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err: DeleteServiceAccountAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type DeleteServiceAccountAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err: DeleteServiceAccountAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type DeleteServiceAccountAuthServiceAccountsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class DeleteServiceAccountAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: DeleteServiceAccountAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteServiceAccountAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type DeleteServiceAccountAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class DeleteServiceAccountAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountAuthServiceAccountsResponseBodyData;

  constructor(
    err: DeleteServiceAccountAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteServiceAccountAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type DeleteServiceAccountResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class DeleteServiceAccountResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountResponseBodyData;

  constructor(
    err: DeleteServiceAccountResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteServiceAccountResponseBody";
  }
}

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    DeleteServiceAccountAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    DeleteServiceAccountAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    DeleteServiceAccountAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountAuthServiceAccountsResponseResponseBody
  > = z.instanceof(DeleteServiceAccountAuthServiceAccountsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteServiceAccountAuthServiceAccountsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteServiceAccountAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountAuthServiceAccountsResponseBody
  > = z.instanceof(DeleteServiceAccountAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountResponseBody$inboundSchema: z.ZodType<
  DeleteServiceAccountResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteServiceAccountResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteServiceAccountResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteServiceAccountResponseBody$outboundSchema: z.ZodType<
  DeleteServiceAccountResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteServiceAccountResponseBody
> = z.instanceof(DeleteServiceAccountResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
